import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Stack from '@mui/material/Stack';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { stepUrls } from 'src/components/Product/Shared/Helpers/stepUrls';
import { useDecodedParams } from 'src/hooks/useDecodedParams';
import { RepairDetailContext } from '../../../../../../providers/repairs/RepairDetails';
import { isWithinIframe } from '../../../../../../services/checkForIframe';
import { workInstructionsLink } from '../../../../../../utils/urls';
import { ProductParams } from './index';
import { StepButton } from './StepButton';

export function StepButtons() {
  const { productId, section } = useDecodedParams<ProductParams>();
  const repairDetails = useContext(RepairDetailContext);
  const { search: tagUrlSection } = useLocation();
  const { t } = useTranslation('workInstructions');

  if (!repairDetails) {
    return null;
  }

  const { step, repair } = repairDetails;
  const { nextStepUrl, prevStepUrl } = stepUrls(repair, step);
  const repairsHome = workInstructionsLink(productId);
  const currentRepairStart = workInstructionsLink(productId, section);

  const nextStepURL = `${
    isWithinIframe ? /* istanbul ignore next */ nextStepUrl || currentRepairStart : nextStepUrl || repairsHome
  }${tagUrlSection}`;

  const previousStepURL = `${
    isWithinIframe ? /* istanbul ignore next */ prevStepUrl || currentRepairStart : prevStepUrl || repairsHome
  }${tagUrlSection}`;

  return (
    // Flex layout
    <Stack
      direction="row"
      justifyContent="space-around"
      alignItems="center"
      sx={{
        gap: '1rem',
        padding: '0 1rem 1rem',
      }}
    >
      {/* Previous Step Button */}
      <StepButton
        startIcon={<FontAwesomeIcon icon={faChevronLeft} />}
        to={previousStepURL}
        data-testid="previous-step-button"
        disabled={prevStepUrl === undefined}
      >
        {t('repairStep.prevStep')}
      </StepButton>

      {/* Next Step Button */}
      <StepButton endIcon={<FontAwesomeIcon icon={faChevronRight} />} to={nextStepURL} data-testid="next-step-button">
        {nextStepUrl ? t('repairStep.nextStep') : t('repairStep.complete')}
      </StepButton>
    </Stack>
  );
}
